
// environment level providers for use by the entire application (including common code)

import {NgModule} from "@angular/core";
import {WINDOW_LISTENER_TOKEN, WindowHostListenerService} from "../common/window/window.host.listener.service";
import {WINDOW_TOKEN, WindowEventsBrowserService} from "../common/window/window.events.browser.service";
import {BrowserAttributes} from "../common/browser/detect.browser";
import {WindowRef} from "../common/ui/services/window.ref";
import {ELEMENT_TOKEN, ElementBrowserService} from "../common/element/element.service";
import {DOCUMENT_SIZE_DETECTOR_TOKEN, DocumentSizeDetector} from "../common/window/document.size";
import {WorkstationLockDetectionService} from "../common/window/workstation-lock-detection.service";
import {ClientContextProxy} from "../common/client.context/services/client.context.proxy";
import {ClientContextService} from "../common/client.context/services/client.context.service";
import {VersionDetailsService} from "../common/version.details/services/version.details.service";
import {VersionDetailsProxy} from "../common/version.details/services/version.details.proxy";
import {TimezoneService} from "../common/datetime/services/timezone.service";
import {TimezoneProxy} from "../common/datetime/services/timezone.proxy";
import {DetectBrowserFeatureService} from "../common/browser/detect.browser.feature.service";

@NgModule({

})
export class EnvironmentModule {
	public static forRoot(){
		return {
			ngModule: EnvironmentModule,
			providers: [
				{provide: WINDOW_LISTENER_TOKEN, useClass: WindowHostListenerService},
				{provide: WINDOW_TOKEN, useClass: WindowEventsBrowserService},
				{provide: ELEMENT_TOKEN, useClass: ElementBrowserService},
				{provide: DOCUMENT_SIZE_DETECTOR_TOKEN, useClass: DocumentSizeDetector},
				BrowserAttributes, WindowRef,//,
				DetectBrowserFeatureService,
				WorkstationLockDetectionService,
				ClientContextProxy,
				ClientContextService,
				VersionDetailsService,
				VersionDetailsProxy,
				TimezoneService,
				TimezoneProxy
				//{provide:DOCUMENT, useValue:document} // do not try to use our own document wrapper it's probably not supported
			]
		};
	}
}

